import { HiddenLightReachInfoForEpcUser } from '@/components/auth/HiddenLightReachInfoToEpcUser';

export interface ActivityEvent {
  id?: string;
  associatedEntities?: Array<{
    id?: string;
    type?: string;
  }>;
  eventType?: string;
  data?: Record<string, unknown>;
  performedBy?: {
    id?: string;
    displayName?: string;
    organizationId?: string;
  };
  createdAt?: string | Date;
}

const palmettoFinanceOrgAlias = 'sabal';

const EventBy = ({ event }: { event: ActivityEvent }) => {
  const { displayName, organizationId } = event.performedBy || {};
  const isEpcUser = (organizationId && organizationId !== palmettoFinanceOrgAlias) || false;

  return (
    <HiddenLightReachInfoForEpcUser
      children={<strong>{displayName}</strong>}
      fallbackChildren={isEpcUser ? <strong>{displayName}</strong> : <strong>LightReach Support</strong>}
    />
  );
};

export default EventBy;
